import LoadingGif from "@public/img/loading.gif";
import TrashIcon from "@public/img/trash.svg";
import PhoneIcon from "@public/img/phone-device.svg";
import TvIcon from "@public/img/tv-device.svg";
import WebIcon from "@public/img/web-device.svg";
import DesktopIcon from "@public/img/desktop-device.svg";
import React, { useContext, useEffect, useState } from "react";
import { AppContextType, WonmovContext } from "@/context/app-context";
import { DeviceData } from "@/entry/server/user";
import { userRepo } from "@/repo/user-repo";

var MAX_DEVICES = 5;

function getDeviceIcon(deviceType: string) {
    switch (deviceType) {
        case "android":
        case "ios":
            return PhoneIcon;
        case "tv":
            return TvIcon;
        case "web":
            return WebIcon;
        case "windows":
        case "linux":
        case "macos":
            return DesktopIcon;
        default:
            return WebIcon;
    }
}

function DeviceRow({
    device,
    onDelete,
}: {
    device: DeviceData;
    onDelete: () => void;
}) {
    return (
        <div className="profile-devices__item" dir="ltr">
            <button
                type="button"
                onClick={function (e) {
                    e.stopPropagation();
                    onDelete();
                }}
                className="profile-devices__delete"
            >
                <img src={TrashIcon} alt="حذف" />
            </button>

            <img
                src={getDeviceIcon(device.device_type)}
                alt={device.device_name}
                className="profile-devices__icon"
            />

            <div className="profile-devices__info" dir="rtl">
                <p className="profile-devices__name">
                    {device.device_name}
                    {device.is_primary && (
                        <span className="profile-devices__primary">(دستگاه اصلی)</span>
                    )}
                </p>
            </div>
        </div>
    );
}

export default function DevicesPage() {
    var setNotification = useContext<AppContextType>(WonmovContext).setNotification;
    var devicesState = useState<DeviceData[]>([]);
    var devices = devicesState[0];
    var setDevices = devicesState[1];
    var loadingState = useState(true);
    var loading = loadingState[0];
    var setLoading = loadingState[1];
    var actionLoadingState = useState(false);
    var actionLoading = actionLoadingState[0];
    var setActionLoading = actionLoadingState[1];

    var loadDevices = function () {
        setLoading(true);
        userRepo.getDevices().then(function (res) {
            if (res.status) {
                setDevices(res.data ? res.data : []);
            } else {
                setNotification({ type: "danger", message: res.message });
            }
            setLoading(false);
        });
    };

    useEffect(function () {
        loadDevices();
    }, []);

    var handleDelete = function (device: DeviceData) {
        if (actionLoading) {
            return;
        }
        if (!window.confirm("آیا می‌خواهید این دستگاه را حذف کنید؟")) {
            return;
        }

        setActionLoading(true);
        userRepo.deleteDevice(device.device_token).then(function (res) {
            setActionLoading(false);

            if (!res.status) {
                setNotification({ type: "danger", message: res.message });
                return;
            }

            setNotification({ type: "success", message: "دستگاه با موفقیت حذف شد" });
            setDevices(function (prev) {
                return prev.filter(function (d) {
                    return d.device_token !== device.device_token;
                });
            });
        });
    };

    return (
        <div className="profile-panel profile-devices">
            <h2 className="profile-panel__title">
                دستگاه های فعال ({devices.length}/{MAX_DEVICES})
            </h2>

            <div className="profile-devices__list">
                {loading && (
                    <div className="profile-devices__loading">
                        <img src={LoadingGif} alt="loading" />
                    </div>
                )}

                {!loading && devices.length === 0 && (
                    <div className="profile-devices__empty">
                        <p className="profile-devices__empty-title">دستگاه فعالی وجود ندارد</p>
                    </div>
                )}

                {!loading &&
                    devices.map(function (device) {
                        return (
                            <DeviceRow
                                key={device.device_token}
                                device={device}
                                onDelete={function () {
                                    handleDelete(device);
                                }}
                            />
                        );
                    })}
            </div>
        </div>
    );
}
